import { render, staticRenderFns } from "./SalesTeam.vue?vue&type=template&id=70419abb&scoped=true"
import script from "./SalesTeam.vue?vue&type=script&lang=js"
export * from "./SalesTeam.vue?vue&type=script&lang=js"
import style0 from "./SalesTeam.vue?vue&type=style&index=0&id=70419abb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70419abb",
  null
  
)

export default component.exports